import { useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import { type ExtensionActionAvailability, getExtensionBlockedMessageKeys, resolveCurrentExtensionBlock } from '@/shared/utils/currentExtensionBlock';
import { alertDialog } from '@/ui_v3';

/**
 * 연장이 차단된 상태면 안내 다이얼로그를 띄우고 `true` 를 돌려준다.
 *
 * 호출부는 `true` 일 때 결제 진입을 중단한다. 업셀링 모달과 플랜 관리 화면이
 * 같은 판정·같은 문구를 쓰도록 여기 한 곳에 둔다 — 예전에는 플랜 관리 화면에만
 * 인라인으로 있어서 다른 진입점이 그대로 결제 화면까지 통과했다.
 *
 * 네임스페이스는 `common` 고정이다. 업셀링 모달을 통해 어느 페이지에서든 뜰 수
 * 있는데 `billing` 은 `/profile/plan`·`/checkout*` 에서만 로드되기 때문이다.
 * 자세한 이유는 `getExtensionBlockedMessageKeys` 주석 참고.
 */
export const useExtensionBlockedAlert = () => {
  const {
    t
  } = useTranslation(['common']);
  return useCallback((actions: ExtensionActionAvailability | undefined): boolean => {
    const block = resolveCurrentExtensionBlock(actions);
    if (!block.blocked) return false;
    const messageKeys = getExtensionBlockedMessageKeys(block.reason);
    const title = t(messageKeys.title);
    const description = t(messageKeys.description);
    alertDialog.open({
      size: 'xs',
      header: {
        title
      },
      body: description,
      hasDim: true,
      shouldCloseOnDimClick: false
    });
    return true;
  }, [t]);
};